import { request } from './client';

/**
 * Everything waiting on the signed-in player, in one read.
 *
 * The per-league and per-game endpoints are the right shape for the pages that
 * own those things, and no use to a landing page that does not yet know which
 * leagues or games to ask about - hence one cross-cutting call rather than a fan
 * out of them. The account comes from the session, so there is nothing to pass.
 *
 * Rows carry ids and counts, not sentences: the wording lives with the component.
 */
export function getPendingActions() {
  return request('/api/customer/notifications');
}
